<template>
    <v-card outlined>
        <div class="bMolecule white--text pa-4">
            <div class="subtitle-1 font-weight-medium">Begin your molecule with your 5 attributes which defines you.</div>
            <div class="d-flex align-center">
                <v-icon size="10" color="white" class="mr-2">fa-bullhorn</v-icon>
                <div class="caption">Only one word per attribute.</div>
            </div>
        </div>

        <v-card-text class="pa-6">
            <v-text-field
                v-model="model.a1"
                label="1."
                outlined dense
                maxlength="20"
                @keydown.enter="validate"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="bMolecule" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <v-text-field
                v-model="model.a2"
                label="2."
                outlined dense
                maxlength="20"
                @keydown.enter="validate"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="bMolecule" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <v-text-field
                v-model="model.a3"
                label="3."
                outlined dense
                maxlength="20"
                @keydown.enter="validate"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="bMolecule" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <v-text-field
                v-model="model.a4"
                label="4."
                outlined dense
                maxlength="20"
                @keydown.enter="validate"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="bMolecule" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <v-text-field
                v-model="model.a5"
                label="5."
                outlined dense
                maxlength="20"
                @keydown.enter="validate"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="bMolecule" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <v-divider></v-divider>

            <div class="d-flex align-center justify-center ml-10 mt-2">
                <v-icon size="10" color="bMolecule" class="mr-2">fa-exclamation-triangle</v-icon>
                <div class="caption">You can always come back later to edit it.</div>
            </div>

            <div class="text-center mt-6">
                <v-btn text class="grey--text text--darken-1 mr-2" @click="$emit('cancel')">Cancel</v-btn>
                <v-btn depressed large class="bMolecule white--text" @click="validate" :disabled="sending">Save</v-btn>
            </div>

        </v-card-text>
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        sending: false,
        model: {
            a1: '',
            a2: '',
            a3: '',
            a4: '',
            a5: '',
        },
    }),
    props: ['attributes'],
    mounted() {
        window.scrollTo(0, 0);
        this.init();
    },
    methods: {
        init() {
            this.model = JSON.parse(JSON.stringify(this.attributes));
        },
        validate() {
    		if ( this.validateIsEmpty(this.model.a1) || this.validateIsEmpty(this.model.a2) || this.validateIsEmpty(this.model.a3) || this.validateIsEmpty(this.model.a4) || this.validateIsEmpty(this.model.a5) ) {
                this.$store.dispatch('setSnack', {kind:'error', text:'All the 5 attributes are needed.'});
                window.scrollTo(0, 0);
                return;
            }
            this.save(); 
        },
        save() {
            this.sending = true;

            Personal.updateAttributes(this.user.uid, this.model)
                    .then(response => {
                        if (response === true) {
                            this.$store.dispatch('setAttributes', this.model);
                            this.$emit('changed', 'attributes');
                            this.$store.dispatch('setSnack', {kind:'success', text:'Attributes Molecule has been updated.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>

<style scoped>
    a {
        color: white !important;
    }
</style>
